module.exports = __webpack_public_path__ + "img/twbglhc_icon.75cc867a.png";